import RightDash from 'components/RightDash'
import UserContext from 'contexts/UserContext'
import BeneficiaryContext from 'contexts/beneficiaryContext'
import React, { useContext, useEffect, useState } from 'react'
import {  useNavigate } from 'react-router-dom'
import { getListBeneficary } from 'requests/benificary'
import { userLatsTransfers } from '../../requests/transfer'
import Modif from '../../assets/modif.svg'


import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'

import { useTranslation } from 'react-i18next'
import ContainerHome from 'containers/containerHome/containerHome'

type CountryConfig = {
  valuePays: string
  codeIso: string
}

interface PersonalInfo {
  firstName: string
  lastName: string
  phone: {
    prefix: string
    number: string
  }
  avatar?: number
  gender?: 'male' | 'female'

  recipient?: {
    avatar: 1
    personalInfo: {
      firstName: 'string'
    }
  }
}

const COUNTRY_MAP: Record<string, CountryConfig> = {
  '216': { valuePays: 'TND', codeIso: 'TUN' },
  '221': { valuePays: 'XOF', codeIso: 'SEN' },
  '212': { valuePays: 'MAD', codeIso: 'MAR' },
  '92': { valuePays: 'PKR', codeIso: 'PAK' },
  '880': { valuePays: 'BDT', codeIso: 'BGD' },
  '90': { valuePays: 'TRY', codeIso: 'TUR' },
}

interface Beneficiary {
  _id?: string
  personalInfo?: PersonalInfo
  lastTransferDate?: string
}

const DetailsUserContainer = () => {
  const Navigate = useNavigate()

  const { user } = useContext(UserContext)
  const {t}= useTranslation()
  const {  TransferDataBeneficiary } = useContext(transferBeneficiaryContext)

  const [isAdded, setIsAdded] = useState(false)
  const { setBeneficiaries, beneficiaries } = useContext(BeneficiaryContext)
  const [person, setPerson] = useState<any[]>([])
  const [transactionData, setTransactionData] = useState<any>([])
  const [openModalServices, setOpenModalServices] = useState('')

  const [isModalAddBenefOpen, setIsModalAddBenefOpen] = useState(false)
 
  useEffect(() => {
    const fetchBeneficiaries = async () => {
      if (user?.user?._id && user?.token?.accessToken) {
        try {
          const response = await getListBeneficary(user.user._id, user.token.accessToken)
          const responseT = await userLatsTransfers(user.user._id, user.token.accessToken)
          if (response?.success === true) {
            setPerson(response?.beneficiaries)
          }
          if (responseT?.success === true) {
            setTransactionData(responseT.transfers)
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
    fetchBeneficiaries()
  }, [isAdded, TransferDataBeneficiary, user])

 

  return (
    <div>
      <div className=" w-[350px] xl:w-[250px] pl-4 border-l-[1px] border-[#E2E2FB] pb-[60px] scrollbar-hide overflow-y-auto h-screen fixed top-[40px]  xl:hidden ">
        <div className="flex  h-[80px] justify-between items-center ">
          <div
            className="text-[21px]  font-poppins text-[#0A0A0A] sm:text-[15px]  font-bold hover:cursor-pointer"
            onClick={() => {
              Navigate('/settingProfile/0')
            }}
          >
            {t("detailsRightDash.myAccount")}
          </div>
          <img
            className="hover:cursor-pointer "
            src={Modif}
            alt="Icône de modificationd u profil utilisateur"
            width={70}
            height={70}
            onClick={() => { Navigate('/settingProfile/0')
            }}
          />
        </div>

        <RightDash />
        <ContainerHome />

        
      </div>
   

    </div>
  )
}

export default DetailsUserContainer
